import dayjs, { Dayjs } from 'dayjs';
import { TestResult } from '../../types';
import dateComparer from './dateComparer';

const dateFormat = 'YYYY-MM-DD HH:mm:ss';

const sortIndexMap = {
  fail: 1,
  error: 2,
  warn: 3,
  pass: 4,
  skipped: 5,
  no_data: 6,
} as any;

type StatusValue = { status: string; date?: Dayjs };

export const statusValueComparer = (a: StatusValue, b: StatusValue) => {
  const aIndex = sortIndexMap[a.status.toLowerCase()];
  const bIndex = sortIndexMap[b.status.toLowerCase()];

  return aIndex - bIndex === 0 ? dateComparer(a.date, b.date) : aIndex - bIndex;
};

const statusComparer = (a: TestResult, b: TestResult) => {
  const dateA = dayjs(a.metadata.latest_run_time, dateFormat);
  const dateB = dayjs(b.metadata.latest_run_time, dateFormat);

  return statusValueComparer(
    { status: a.metadata.latest_run_status, date: dateA },
    { status: b.metadata.latest_run_status, date: dateB },
  );
};

export default statusComparer;
